if (document.getElementsByClassName('js-makePassword')[0]) {
  system()
}

function system() {
  /*
  パスワード自動生成
  <input type="text" class="js-makePassword--1 editForm__input--w85" placeholder="">

  <button type="button" class="js-makePassword" data-make-password="1">
自動生成
</button>
*/

  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-makePassword')

    if (!item) {
      return
    }

    const password = makePassword()
    const target = item.dataset.makePassword
    document.querySelector('.js-makePassword--' + target).value = password
  })

  function makePassword() {
    // パスワードに採用する文字列を用意
    const string = '0123456789' + 'abcdefghijklmnopqrstuvwxyz' + 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + '!@#$%^&*_+='
    // 文字数
    const len = 8

    let password = ''
    // ランダムに文字を繋げる
    for (let index = 0; index < len; index++) {
      password += string.charAt(Math.floor(Math.random() * string.length))
    }

      setTimeout(() => {
        window.textCount() // 文字数カウント実行
      }, 500)

    return password
  }
}
